import { WorkPackagesQueryViewService } from 'core-app/features/work-packages/components/wp-list/wp-query-view.service';

export function apply() {
  let proto = WorkPackagesQueryViewService.prototype;
  let viewTypeGetter = Object.getOwnPropertyDescriptor(proto, "viewType")?.get;
  Object.defineProperty(proto, "viewType", {
    get() {
      if (this.$state.includes('work-packages-iframe')) {
        return 'work_packages_table';
      }
      return viewTypeGetter?.apply(this);
    },
  });
}
